export const topBarHelpLinks = [
  {
    key: "academy",
    label: "LEO Academy",
    href: "https://leopharma.sharepoint.com/teams/LEO-PHARMA-ACADEMY/SitePages/LEO-OpenAI.aspx",
  },
  {
    key: "faq",
    label: "FAQ",
    href: "https://leopharma.sharepoint.com/teams/LEO-PHARMA-ACADEMY/Shared%20Documents/Digital%20Skills/LEO%20AI%20FAQ%2018Apr24.pdf",
  },
] as const;
